import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { FaArrowUp } from "react-icons/fa";

const Scollerup = () => {
  
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowButton(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

 const handleScrollTop = () => {
  console.log("Clicked");

  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
}; 

  if (!showButton) return null;

  return (
    <Button
      onClick={handleScrollTop}
      className="rounded-circle d-flex justify-content-center align-items-center border-0 shadow"
      style={{
        position: "fixed",
        bottom: "25px",
        right: "25px",
        width: "55px",
        height: "55px",
        backgroundColor: "var(--primary-color)",
        color: "#fff",
        zIndex: 9999,
        transition: "0.3s",
      }}
      onMouseEnter={(e) =>
        (e.currentTarget.style.backgroundColor = "var(--secondary-color)")
      }
      onMouseLeave={(e) =>
        (e.currentTarget.style.backgroundColor = "var(--primary-color)")
      }
    >
      <FaArrowUp size={20} />
    </Button>
  );
};

export default Scollerup;
